<template>
  <el-dialog
    :title="$t('CargoMsg.Cargo_InstructionRecords')"
    :visible.sync="innerVisible"
    width="870px"
    height="400px"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :grid-params.sync="gridParams"
      :row-data="rowData"
      style="width:100%;height:400px;"
      @gridReady="onGridReady"
    />
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'InstructionRecordsDialog',
  props: {
    visible: { type: Boolean, required: true },
    rowData: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      gridApi: null,
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperationInstructions'),
          field: 'operationInstructions',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.instructionNameLabelFunc(params.data)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'createdBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'dateCreated',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExecuteResult'),
          field: 'executeStatus',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.instructionExecuteStatusLabelFunc(params.value)
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.init()
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    }
  }
}
</script>
